export default {
  BASE_URL: '/admin/expert',
  api: [
    {
      name: 'list',
      desc: '获取列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'save',
      desc: '新增or保存',
      method: 'POST',
      path: '/save'
    },
    {
      name: 'delete',
      desc: '删除',
      method: 'GET',
      path: '/delete'
    },
    {
      name: 'view',
      desc: '获取',
      method: 'GET',
      path: '/view'
    },
    {
      name: 'companyList',
      desc: '获取所有企业的列表',
      method: 'GET',
      path: '/distCompanyList'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/expert/index.js